import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
  IconButton,
  Box,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import { useLoading } from "../../../context/loading";
import { useUserDetails } from "../../../context/auth";
import BASEURL from "../../Utils/Baseurl";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialInput from "../../../components/MaterialInput";
import MaterialSnackbar from "../../../components/MaterialSnackbar";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import request from "graphql-request";

const complaintTypeOptions = [
  { label: "Leave Clarification", value: "Leave Clarification" },
  { label: "Payroll Issues", value: "Payroll Issues" },
  { label: "Benefits Issues", value: "Benefits Issues" },
  { label: "Work Schedule Issues", value: "Work Schedule Issues" },
  { label: "Performance Review Issues", value: "Performance Review Issues" },
  { label: "Other", value: "Other" },
];

const priorityLevelOptions = [
  { label: "Low", value: "Low" },
  { label: "Medium", value: "Medium" },
  { label: "High", value: "High" },
];

const statusOptions = [
  { label: "Low", value: "Low" },
  { label: "Medium", value: "Medium" },
  { label: "High", value: "High" },
];

const AddComplaintForm = () => {
  const navigate = useNavigate();

  const { circleLoading, setCirleLoading } = useLoading();

  const { setdisplay, AccessData, setupdate, user } = useUserDetails();
  const [oneComplaint, setOneComplaint] = useState([]);
  const [fileName, setFileName] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  // const [complaintTypeOptions, setComplaintTypeOptions] = useState([]);

  const [id, setId] = useState(null);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [ComplaintData, setComplaintData] = useState({
    employeeName: "",
    employeeID: "",
    department: "",
    complaintType: "",
    dateOfComplaint: "",
    attachments: "",
    priorityLevel: "",
    description: "",
    other: "",
    assignedHr: "",
    complaintStatus: "",
    resolutionNotes: "",
    // Statuses
    employeeNameStatus: "unchecked",
    employeeIDStatus: "unchecked",
    departmentStatus: "unchecked",
    complaintTypeStatus: "unchecked",
    dateOfComplaintStatus: "unchecked",
    attachmentsStatus: "unchecked",
    priorityLevelStatus: "unchecked",
    descriptionStatus: "unchecked",
    otherStatus: "unchecked",
    assignedHrStatus: "unchecked",
    complaintStatusStatus: "unchecked",
    resolutionNotesStatus: "unchecked",
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      setdisplay(true);
      setTogglePage({
        ...togglePage,
        view: true,
        edit: false,
      });
      getComplaintBid(id);
    } else {
      if (user) {
        setComplaintData((prev) => ({
          ...prev,
          employeeName: user.first_name,
          employeeID: user.empid,
          department: user.department,
          dateOfComplaint: new Date().toISOString().split("T")[0],
          employeeNameStatus: "success",
          employeeIDStatus: "success",
          departmentStatus: "success",
          dateOfComplaintStatus: "success",
        }));
      }
    }

    // getComplaintType();
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
      setSelectedFile(file);
      setComplaintData((prev) => ({
        ...prev,
        attachments: file.name,
        attachmentsStatus: "success",
      }));
    }
  };

  const clearFile = () => {
    setFileName(null);
    setComplaintData((prev) => ({
      ...prev,
      attachments: "",
      attachmentsStatus: "unchecked",
    }));
  };

  const handleIconClick = () => {
    document.getElementById("file-input").click();
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
    setupdate(true);
  };

  const checkAllFields = () => {
    // Common fields to validate
    const commonStatuses = [
      ComplaintData.employeeNameStatus,
      ComplaintData.employeeIDStatus,
      ComplaintData.departmentStatus,
      ComplaintData.complaintTypeStatus,
      ComplaintData.dateOfComplaintStatus,
      ComplaintData.attachmentsStatus,
      ComplaintData.priorityLevelStatus,
      ComplaintData.descriptionStatus,
    ];

    // Include "otherStatus" if complaintType is "Other"
    if (ComplaintData.complaintType === "Other") {
      commonStatuses.push(ComplaintData.otherStatus);
    }

    // If any common status is not "success", validation fails
    if (
      commonStatuses.includes("unchecked") ||
      commonStatuses.includes("error")
    ) {
      return false;
    }

    // HR-specific fields validation
    if (user.role === "HR") {
      const hrStatuses = [
        ComplaintData.assignedHrStatus,
        ComplaintData.complaintStatusStatus,
        ComplaintData.resolutionNotesStatus,
      ];

      if (hrStatuses.includes("unchecked") || hrStatuses.includes("error")) {
        return false;
      }
    }

    // All validations passed
    return true;
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onCancelAction = () => {
    navigate("/complaintForm");
  };

  const handleComplaintDatachange = (event, selectEvent) => {
    let ComplaintState = { ...ComplaintData };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "complaintType") {
        const lengthRegex = new RegExp("^.{1,100}$");
        if (lengthRegex.test(event?.label) === true) {
          ComplaintState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          ComplaintState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "priorityLevel") {
        const lengthRegex = new RegExp("^.{1,100}$");
        if (lengthRegex.test(event?.label) === true) {
          ComplaintState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          ComplaintState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "complaintStatus") {
        const lengthRegex = new RegExp("^.{1,100}$");
        if (lengthRegex.test(event?.label) === true) {
          ComplaintState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          ComplaintState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      ComplaintState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      // eslint-disable-next-line default-case
      switch (event.target.name) {
        case "employeeName":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              ComplaintState[event.target.name + "Status"] = "success";
            } else {
              ComplaintState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "employeeID":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z0-9 ]{1,40})$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              ComplaintState[event.target.name + "Status"] = "success";
            } else {
              ComplaintState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "department":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z0-9 ]{1,40})$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              ComplaintState[event.target.name + "Status"] = "success";
            } else {
              ComplaintState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "other":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z0-9 ]{1,40})$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              ComplaintState[event.target.name + "Status"] = "success";
            } else {
              ComplaintState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "dateOfComplaint":
          {
            const alphaNumberLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              ComplaintState[event.target.name + "Status"] = "success";
            } else {
              ComplaintState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "description":
          {
            const alphaNumberLengthRegex = new RegExp("^.{1,500}$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              ComplaintState[event.target.name + "Status"] = "success";
            } else {
              ComplaintState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "assignedHr":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              ComplaintState[event.target.name + "Status"] = "success";
            } else {
              ComplaintState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "resolutionNotes":
          {
            const alphaNumberLengthRegex = new RegExp("^.{1,500}$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              ComplaintState[event.target.name + "Status"] = "success";
            } else {
              ComplaintState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        ComplaintState[event.target.name] = event.target.value;
      }
    }
    setComplaintData(ComplaintState);
  };

  const onDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteComplaint();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteComplaint = async () => {
    const query = `
            mutation DeleteComplaint { 
deleteComplaint(id: 7) { 
 success 
message 
error 
} 
} 
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      if (response.data.data.deleteComplaint.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Complaint deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/complaintForm");
      } else {
        console.log(
          "Error deleting Complaint:",
          response.data.data.deleteComplaint.message
        );
        Swal.fire({
          position: "center",
          icon: "error",
          title: response.data.data.deleteComplaint.message,
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.error("An error occurred while deleting the Complaint:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onComplaintSubmit = async () => {
    setCirleLoading(true);

    // GraphQL Mutation
    const query = `
    mutation CreateComplaint(
      $userId: Int!
      $departmentId: Int!
      $complaintTypeId: Int!
      $complaintDescription: String!
      $priorityLevel: String!
      $complaintDate: Date!
      $files: [Upload]
      $othersDescription: String!
    ) {
      createComplaint(
        userId: $userId
        departmentId: $departmentId
        complaintTypeId: $complaintTypeId
        complaintDescription: $complaintDescription
        priorityLevel: $priorityLevel
        complaintDate: $complaintDate
        files: $files
        othersDescription: $othersDescription
      ) {
        success
        message
        error
        complaint {
          id
          complaintId
          complaintDescription
          priorityLevel
          complaintDate
          resolutionNotes
          resolutionDate
          status
          createdAt
          lastUpdated
          user {
            id
            username
            firstName
            lastName
            empid
            department
          }
          department {
            id
            departmentName
            departmentCode
          }
          attachments {
            id
            file
          }
          othersDescription
        }
      }
    }
  `;

    // Prepare FormData for multipart request
    const formData = new FormData();
    formData.append(
      "operations",
      JSON.stringify({
        query,
        variables: {
          employeeName: ComplaintData.employeeName,
          userId: ComplaintData.employeeID,
          departmentId: ComplaintData.department,
          complaintTypeId: ComplaintData.complaintType,
          complaintDescription: ComplaintData.description,
          priorityLevel: ComplaintData.priorityLevel,
          complaintDate: ComplaintData.dateOfComplaint,
          files: selectedFile ? [selectedFile] : null,
          othersDescription: ComplaintData.other,
        },
      })
    );

    // Map file to variables.files
    if (selectedFile) {
      formData.append("map", JSON.stringify({ 0: ["variables.files.0"] }));
      formData.append("0", selectedFile);
    }

    try {
      // Axios request
      const response = await axios.post(BASEURL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const result = response.data?.data?.createComplaint;

      if (result?.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Complaint Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/complaintForm");
        setSnackBar((prev) => ({
          ...prev,
          Success: true,
        }));
      } else {
        throw new Error(result?.message || "Unknown error occurred");
      }
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog((prev) => ({
            ...prev,
            open: false,
          }));
        },
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const handleAddComplaintForm = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onComplaintSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const getComplaintBid = async (userId) => {
    const query = `
    query ComplaintsByUser($userId: ID!) { 
      complaintsByUser(userId: $userId) { 
        success 
        message 
        complaints { 
          id 
          complaintId 
          complaintDescription 
          priorityLevel 
          complaintDate 
          resolutionNotes 
          resolutionDate 
          status 
          priorityLevelDisplay 
          statusDisplay 
          createdAt 
          lastUpdated 
          user { 
            id 
            username 
            firstName 
            lastName 
            empid 
            department 
          } 
          department { 
            id 
            departmentName 
            departmentCode 
          } 
          attachments { 
            id 
            file 
          } 
        } 
        error 
      } 
    }
  `;

    try {
      // Dynamic variable for userId
      const variables = { userId };

      // Sending request using the `graphql-request` library
      const response = await request(BASEURL, query, variables);

      // Handle success
      if (response.complaintsByUser?.success) {
        const complaints = response?.complaintsByUser?.complaints;

        setComplaintData((prev) => ({
          ...prev,
          employeeName: complaints?.first_name,
          employeeID: complaints?.empid,
          department: complaints?.department,
          dateOfComplaint: complaints?.dateOfComplaint,
          complaintType: {
            label: complaints?.complaintType,
            value: complaints?.complaintType,
          },
          attachments: complaints?.attachments,
          priorityLevel: {
            label: complaints?.priorityLevel,
            value: complaints?.priorityLevel,
          },
          description: complaints?.description,
          other: complaints?.other,
          assignedHr: complaints?.assignedHr,
          complaintStatus: {
            label: complaints?.complaintStatus,
            value: complaints?.complaintStatus,
          },
          resolutionNotes: complaints?.resolutionNotes,
          employeeNameStatus: "success",
          employeeIDStatus: "success",
          departmentStatus: "success",
          complaintTypeStatus: "success",
          dateOfComplaintStatus: "success",
          attachmentsStatus: "success",
          priorityLevelStatus: "success",
          descriptionStatus: "success",
          otherStatus: "success",
          assignedHrStatus: "success",
          complaintStatusStatus: "success",
          resolutionNotesStatus: "success",
        }));
      } else {
        console.error(
          "Error:",
          response.complaintsByUser?.error || "Unknown error occurred"
        );
      }
    } catch (error) {
      console.error("GraphQL Request Error:", error);
    }
  };

  //   const getComplaintType = async () => {
  //     const query = `query AllComplaintTypes {
  //     allComplaintTypes {
  //     id
  //     name
  //     createdAt
  //     lastUpdated
  //     }
  // } `;

  //     try {
  //       const response = await request(BASEURL, query);
  //       console.log("response", response);
  //       const allComplaintTypes = response?.allComplaintTypes?.map((a) => ({
  //         value: a?.id,
  //         label: a?.name,
  //       }));
  //       setComplaintTypeOptions(allComplaintTypes);
  //     } catch (error) {}
  //   };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "EditDesignation" && item.can_access
                ) && (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        {togglePage.view
                          ? "View Complaint Details"
                          : togglePage.edit
                          ? "Edit Complaint Details"
                          : "Add Complaint Details"}
                      </MaterialTypography>
                    </Stack>

                    {(togglePage.view || togglePage.edit) && (
                      <>
                        <ButtonGroup
                          variant="outlined"
                          aria-label="Loading button group"
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>
                          {/* Uncomment this block to add delete functionality */}

                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={onDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      </>
                    )}
                  </Stack>
                )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "55vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Employee Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="employeeName"
                  value={ComplaintData.employeeName}
                  onChange={handleComplaintDatachange}
                  error={ComplaintData.employeeNameStatus === "error"}
                  success={ComplaintData.employeeNameStatus === "success"}
                  disabled={togglePage.view}
                />
                {ComplaintData.employeeNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Complaint Name should be a maximum of 40 characters long
                      and can contain only alphabets.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Employee ID <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="employeeID"
                  value={ComplaintData.employeeID}
                  onChange={handleComplaintDatachange}
                  error={ComplaintData.employeeIDStatus === "error"}
                  success={ComplaintData.employeeIDStatus === "success"}
                  disabled={togglePage.view}
                />
                {ComplaintData.employeeIDStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Complaint Name should be a maximum of 40 characters long
                      and can contain only alphabets.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Department <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="department"
                  value={ComplaintData.department}
                  onChange={handleComplaintDatachange}
                  error={ComplaintData.departmentStatus === "error"}
                  success={ComplaintData.departmentStatus === "success"}
                  disabled={togglePage.view}
                />
                {ComplaintData.departmentStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Complaint Name should be a maximum of 40 characters long
                      and can contain only alphabets.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Complaint Type <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="complaintType"
                  value={ComplaintData.complaintType}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleComplaintDatachange} //selectedValue, event
                  options={complaintTypeOptions}
                  error={
                    ComplaintData.complaintTypeStatus === "error" ? true : false
                  }
                  success={
                    ComplaintData.complaintTypeStatus === "success"
                      ? true
                      : false
                  }
                  // isClearable
                  isDisabled={togglePage.view}
                />
              </Grid>

              {ComplaintData?.complaintType?.value === "Other" && (
                <Grid size={{ xs: 5, sm: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Other <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="other"
                    value={ComplaintData.other}
                    onChange={handleComplaintDatachange}
                    error={ComplaintData.otherStatus === "error"}
                    success={ComplaintData.otherStatus === "success"}
                    disabled={togglePage.view}
                  />
                  {ComplaintData.otherStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        Complaint Name should be a maximum of 40 characters long
                        and can contain only alphabets.
                      </FormHelperText>
                    </FormControl>
                  )}
                </Grid>
              )}

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Complaint Description{" "}
                    <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  multiline
                  rows={3}
                  name="description"
                  value={ComplaintData.description}
                  onChange={handleComplaintDatachange}
                  error={ComplaintData.descriptionStatus === "error"}
                  success={ComplaintData.descriptionStatus === "success"}
                  disabled={togglePage.view}
                />
                {ComplaintData.descriptionStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Complaint Name should be a maximum of 40 characters long
                      and can contain only alphabets.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Priority Level <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="priorityLevel"
                  value={ComplaintData.priorityLevel}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleComplaintDatachange} //selectedValue, event
                  options={priorityLevelOptions}
                  error={
                    ComplaintData.priorityLevelStatus === "error" ? true : false
                  }
                  success={
                    ComplaintData.priorityLevelStatus === "success"
                      ? true
                      : false
                  }
                  // isClearable
                  isDisabled={togglePage.view}
                />
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Attachments <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                >
                  <input
                    type="file"
                    id="file-input"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  <Box
                    sx={{
                      height: "100px",
                      width: "100%",
                      padding: 2,
                      border: "2px dashed #ccc",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {fileName ? (
                      <MaterialTypography
                        sx={{ fontSize: "14px" }}
                        variant="body1"
                      >
                        {fileName}{" "}
                        <Tooltip title="ClearFile">
                          <IconButton>
                            {" "}
                            <DeleteOutlineRoundedIcon onClick={clearFile} />
                          </IconButton>
                        </Tooltip>
                      </MaterialTypography>
                    ) : (
                      <Tooltip title="Click Upload file">
                        <IconButton
                          onClick={handleIconClick}
                          aria-label="upload"
                          disabled={togglePage.view}
                        >
                          <AttachFileIcon fontSize="large" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                </div>
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Date Of Complaint <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="date"
                  name="dateOfComplaint"
                  value={ComplaintData.dateOfComplaint}
                  onChange={handleComplaintDatachange}
                  error={ComplaintData.dateOfComplaintStatus === "error"}
                  success={ComplaintData.dateOfComplaintStatus === "success"}
                  disabled={togglePage.view}
                />
                {ComplaintData.dateOfComplaintStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Complaint Name should be a maximum of 40 characters long
                      and can contain only alphabets.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              {user.role === "HR" && (
                <Grid size={{ xs: 5, sm: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Assigned HR Personnel{" "}
                      <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="assignedHr"
                    value={ComplaintData.assignedHr}
                    onChange={handleComplaintDatachange}
                    error={ComplaintData.assignedHrStatus === "error"}
                    success={ComplaintData.assignedHrStatus === "success"}
                    disabled={togglePage.view}
                  />
                  {ComplaintData.assignedHrStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        Complaint Name should be a maximum of 40 characters long
                        and can contain only alphabets.
                      </FormHelperText>
                    </FormControl>
                  )}
                </Grid>
              )}

              {user.role === "HR" && (
                <Grid size={{ xs: 5, sm: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Status <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="complaintStatus"
                    value={ComplaintData.complaintStatus}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handleComplaintDatachange} //selectedValue, event
                    options={statusOptions}
                    error={
                      ComplaintData.complaintStatusStatus === "error"
                        ? true
                        : false
                    }
                    success={
                      ComplaintData.complaintStatusStatus === "success"
                        ? true
                        : false
                    }
                    // isClearable
                    isDisabled={togglePage.view}
                  />
                </Grid>
              )}

              {user.role === "HR" && (
                <Grid size={{ xs: 5, sm: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Resolution Notes <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    multiline
                    rows={3}
                    name="resolutionNotes"
                    value={ComplaintData.resolutionNotes}
                    onChange={handleComplaintDatachange}
                    error={ComplaintData.resolutionNotesStatus === "error"}
                    success={ComplaintData.resolutionNotesStatus === "success"}
                    disabled={togglePage.view}
                  />
                  {ComplaintData.resolutionNotesStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        Complaint Name should be a maximum of 40 characters long
                        and can contain only alphabets.
                      </FormHelperText>
                    </FormControl>
                  )}
                </Grid>
              )}
            </Grid>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <>
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={handlecancel}
            >
              {togglePage.view ? "Back" : "Cancel"}
            </MaterialButton>
            {togglePage.view === false && (
              <MaterialButton
                sx={{ m: 4, marginLeft: "4px" }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleAddComplaintForm}
              >
                {togglePage.edit ? "Update" : "Submit"}
              </MaterialButton>
            )}
          </>
        </MaterialBox>
        {
          <MaterialSnackbar
            color="success"
            icon={<NotificationsIcon />}
            title="Message"
            content="You have been submitted successfully"
            open={snackBar.Success}
            close={() =>
              setSnackBar({
                success: false,
              })
            }
          />
        }
      </Card>
    </DashboardLayout>
  );
};

export default AddComplaintForm;
